import { call, select, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import {
    fetchAffordabilityFailure,
    fetchAffordabilitySuccess,
    setMemberAffordabilty
} from '@actions/ssap/ssapActionCreators';
import { getCoverageYear } from '@reducers/appReducer';

export function* affordabilitySaga() {
    try {
        const coverageYear = yield select(getCoverageYear);
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const affordability = yield call([ssapService, ssapService.getAffordability], { coverageYear });
        if(affordability) {
            yield put(fetchAffordabilitySuccess());
            yield put(setMemberAffordabilty(affordability));
        } else {
            yield put(fetchAffordabilityFailure());
        }
    } catch(e) {
        yield put(fetchAffordabilityFailure());
    }
}